// extracted by mini-css-extract-plugin
export default {"area":"ResearcherModal_area__feUTj","modal":"ResearcherModal_modal__An7Rm","exit":"ResearcherModal_exit__gq6iW","text":"ResearcherModal_text__D-DNn"};